module.exports = __webpack_public_path__ + "static/bricks-69ca7da6feb6d0422195b80d5e1b5945.svg";